// This file handles Google Drive OAuth callback
// It should be called when the page loads to check for OAuth tokens in the URL

export const handleGoogleDriveOAuthCallback = (onSuccess) => {
  // Check if we're returning from Google OAuth
  const { hash } = window.location;

  if (hash && hash.includes('access_token')) {
    try {
      // Parse the hash parameters
      const params = new URLSearchParams(hash.substring(1));
      const accessToken = params.get('access_token');
      const state = params.get('state');

      // Verify state matches
      const storedState = sessionStorage.getItem('googleDriveOAuthState');

      if (state === storedState && accessToken) {
        // Fetch user info from Google
        fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((userInfo) => {
            const email = userInfo.email || 'Unknown';

            // Clean up
            sessionStorage.removeItem('googleDriveOAuthState');

            // Clear the hash from URL
            window.history.replaceState(null, null, window.location.pathname);

            // Call success callback if provided
            if (onSuccess) {
              onSuccess({ accessToken, email });
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error fetching Google user info:', error);
            sessionStorage.removeItem('googleDriveOAuthState');
          });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error handling Google Drive OAuth callback:', error);
    }
  }
};
